export function HuiList() {
    return {
        restrict: 'E',
        replace: true,
        scope: true,
        controller: () => {
        },
        bindToController: {
            variant: '@',
            color: '@',
        },
        controllerAs: '$huiCtrl',
        transclude: true,
        template: ($element, $attrs) => {
            return `
                <ol class="hui hui-list"
                 ng-class="[($huiCtrl.variant || 'outline'),
                            'hui-' + ($huiCtrl.color || 'accent')]"
                            ng-transclude></ol>
            `;
        }
    }
}

export function HuiListItem() {
    return {
        restrict: 'E',
        replace: true,
        scope: true,
        controller: () => {
        },
        bindToController: {
            background: '<',
            active: '<'
        },
        controllerAs: '$huiCtrl',
        transclude: true,
        template: ($element, $attrs) => {
            return `
                <li class="hui hui-list-item"
                 ng-class="[$huiCtrl.background ? 'list-background': '', 
                            $huiCtrl.active ? 'active': '']"
                 ng-transclude></li>
            `;
        }
    }
}